/**
 * ==============================================================================
 * Lady Milan - Navigation Menu Controller
 * ==============================================================================
 */

window.openLadyMilanMenu = function() {
  const menuOverlay = document.getElementById('lm-menu-overlay');
  if (menuOverlay) {
    menuOverlay.classList.add('is-open');
    document.body.classList.add('lm-menu-is-open');
    document.body.style.overflow = 'hidden';
  }
};

window.closeLadyMilanMenu = function() {
  const menuOverlay = document.getElementById('lm-menu-overlay');
  if (menuOverlay) {
    menuOverlay.classList.remove('is-open');
    document.body.classList.remove('lm-menu-is-open');
    document.body.style.overflow = '';
  }
};

document.addEventListener('DOMContentLoaded', () => {
  const hamburgerBtns = document.querySelectorAll('.lm-hero-hamburger-btn, .lm-hamburger-btn, .lm-header-hamburger-btn');
  const closeBtns = document.querySelectorAll('.lm-menu-close-btn');
  const accordionBtns = document.querySelectorAll('.lm-menu-accordion-btn');
  const headerBar = document.querySelector('.lm-header-bar');

  hamburgerBtns.forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.stopPropagation();
      e.preventDefault();
      window.openLadyMilanMenu();
    });
  });

  closeBtns.forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.stopPropagation();
      e.preventDefault();
      window.closeLadyMilanMenu();
    });
  });

  // Sticky Scroll Detection for Header Bar (Only enabled on Shop & Product pages)
  if (headerBar && headerBar.dataset.allowSticky === 'true') {
    let lastScroll = 0;
    const getScrollThreshold = () => {
      const hero = document.querySelector('.lm-collection-hero-stage, .lm-subpage-hero-stage, .lm-blog-hero-stage, .lm-article-hero-stage');
      if (hero) {
        return Math.max(80, hero.offsetHeight - (window.innerWidth < 768 ? 64 : 76));
      }
      return window.innerWidth < 768 ? 160 : 300;
    };

    window.addEventListener('scroll', () => {
      const currentScroll = window.scrollY || window.pageYOffset;
      const threshold = getScrollThreshold();
      if (currentScroll > threshold) {
        headerBar.classList.add('is-scrolled');
      } else {
        headerBar.classList.remove('is-scrolled');
      }
      lastScroll = currentScroll;
    }, { passive: true });
  }

  // Close on Escape Key
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      window.closeLadyMilanMenu();
    }
  });

  // Accordion submenus
  accordionBtns.forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      const parentRow = btn.closest('.lm-menu-item-row');
      if (parentRow) {
        const isOpen = parentRow.classList.contains('is-open');
        document.querySelectorAll('.lm-menu-item-row.is-open').forEach((r) => {
          if (r !== parentRow) r.classList.remove('is-open');
        });
        if (isOpen) {
          parentRow.classList.remove('is-open');
          btn.setAttribute('aria-expanded', 'false');
        } else {
          parentRow.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
        }
      }
    });
  });
});
